module.exports = __webpack_public_path__ + "media/images/icon-like-on@3x-cfa2fc1eb0dcc1946ab69623a90041b6.png";